<template lang="pug">
div
  Table
  SharePayments.my-3
  CombineMenus.my-3
</template>

<script>
import { mapActions } from "vuex";
import CombineMenus from "./CombineMenus";
import SharePayments from "./SharePayments";
import Table from "./Table/index";

export default {
  components: { Table, SharePayments, CombineMenus },
  mounted() {
    this.load();
  },
  destroyed() {
    this.setBizAccounts([]);
  },
  methods: {
    ...mapActions(["setBizAccounts"]),
    async load() {
      const params = {
        criteria: {
          $and: [
            { "payments.managed_account": { $exists: true, $ne: "" } },
            { "payments.managed_account": { $ne: null } },
          ],
        },
        select:
          "name short_name status orderType tax_items online_start pos_start created address industry geo_service_zone url standing",
      };
      const result = await this.$api.biz.list(params);
      this.setBizAccounts(result);
    },
  },
};
</script>
